import React, { Component } from 'react';
import { CardLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

class DownloadButtons extends Component {
  render() {
    const { fileName, text, mweList } = this.props;
    const hrefData = `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`;
    const hrefMweListData = `data:text/plain;charset=utf-8,${encodeURIComponent(mweList.join('\n'))}`;
    return (
      <React.Fragment>
        <CardLink href={hrefData} download={`${fileName}`}>
          <FontAwesomeIcon size="sm" icon={faDownload}/> Atsisiųsti anotuotą tekstą
        </CardLink>
        <CardLink href={hrefMweListData} download={`junginiai-${fileName}`}>
          <FontAwesomeIcon size="sm" icon={faDownload}/> Atsisiųsti junginius
        </CardLink>
      </React.Fragment>
    );
  }
}

export default DownloadButtons;